module.exports = __webpack_public_path__ + "static/media/FNALogo.892064f6.png";